import { useEffect, useState } from 'react';
import { Progress } from 'antd';
import './style.scss';
import { AdminApi } from '../../api/Admin';
import LoadingSmall from '../../components/LoadingSmall';
import { formatNumber } from '../Utils';

const DashboardPage = () => {
    const [summary, setSummary] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const getSummary = async () => {
        setLoading(true);
        try {
            const res = await AdminApi.GetDashboardSummary();
            if (res) {
                setSummary(res?.data);
            } else {
                setSummary(null);
            }
        } catch (err: any) {
            setLoading(false);
            setSummary(null);
            console.log(err);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        getSummary();
    }, []);

    const calculateDailyCapStatus = () => {
        if (summary?.dailyCapStatus > 0 && summary?.volume24h) {
            return (summary?.volume24h / summary?.dailyCapStatus) * 100;
        } else {
            return 0;
        }
    }

    return (
        <div className="page active">
            <h1 className="dashboard-page-title">Dashboard</h1>
            <div className="dashboard-content">
                <div className="stats-grid">
                    <div className="stat-card">
                        <div className="stat-card-title">Total Synced Users</div>
                        {loading ? (
                            <p className="stat-card-value">
                                <LoadingSmall />
                            </p>
                        ) : (
                            <p className="stat-card-value">
                                {formatNumber(summary?.totalSyncedUser, 2) || 'N/A'}
                            </p>
                        )}

                    </div>
                    <div className="stat-card">
                        <div className="stat-card-title">Total Volume (USDT)</div>
                        {loading ? (
                            <p className="stat-card-value">
                                <LoadingSmall />
                            </p>
                        ) : (
                            <p className="stat-card-value">
                                {formatNumber(summary?.totalVolume, 2) || 'N/A'}
                            </p>
                        )}
                    </div>
                    <div className="stat-card">
                        <div className="stat-card-title">24h Volume (USDT)</div>
                        {loading ? (
                            <p className="stat-card-value">
                                <LoadingSmall />
                            </p>
                        ) : (
                            <p className="stat-card-value">
                                {formatNumber(summary?.volume24h, 2)}
                            </p>
                        )}
                    </div>
                </div>
                <div className="stat-card full-width">
                    <div className="stat-card-title">Daily Cap Status</div>
                    <div className="daily-cap-details">
                        {loading ? (
                            <p className="stat-card-value">
                                <LoadingSmall />
                            </p>
                        ) : (
                            <p className="stat-card-value">
                                {formatNumber(summary?.volume24h, 2)} / {formatNumber(summary?.dailyCapStatus, 2)}
                            </p>
                        )}
                        {loading ? (
                            <span className="stat-card-value">
                                <LoadingSmall />
                            </span>
                        ) : (
                            <span className="stat-card-value">{formatNumber(calculateDailyCapStatus(), 2)}%</span>
                        )}
                    </div>
                    <div className="progress-bar-container">
                        <Progress
                            percent={loading ? 0 : calculateDailyCapStatus()}
                            showInfo={false}
                            strokeColor="#2E9DB1"
                            trailColor="#E2E8F0"
                            size="default"
                        />
                    </div>
                </div>
            </div>
        </div>
    )

};

export default DashboardPage;


